import React, { Suspense, lazy } from 'react';
import SectionHeading from './SectionHeading';
import { regions } from '../mock/mock';

const Globe3D = lazy(() => import('./Globe3D'));

export default function GlobalGrowth() {
  return (
    <section className="relative max-w-7xl mx-auto px-5 md:px-8 section-pad">
      <SectionHeading
        eyebrow="Global Reach"
        title={<span>Built for <span className="text-gradient">Global Growth.</span></span>}
        subtitle="From emerging markets to mature economies, we help brands scale performance campaigns across the world."
      />

      <div className="reveal relative glass-strong rounded-3xl p-6 md:p-8 overflow-hidden">
        <div className="orb w-[420px] h-[420px] bg-[#2563eb]/20 top-0 left-1/3" aria-hidden />
        <div className="relative grid lg:grid-cols-5 gap-8 items-center">
          <div className="lg:col-span-3">
            <Suspense fallback={<div className="h-[420px] grid place-items-center text-slate-500 text-sm">Loading global network…</div>}>
              <Globe3D />
            </Suspense>
          </div>
          <div className="lg:col-span-2">
            <h3 className="font-display text-2xl font-bold text-slate-900">A worldwide performance network</h3>
            <p className="mt-3 text-slate-600 leading-relaxed text-sm">
              Interscope runs campaigns across every major region — with localized creative, geo-tuned bidding and a diversified inventory ecosystem spanning OEM, programmatic, social and CTV.
            </p>
            <div className="mt-6 grid grid-cols-2 gap-3">
              {regions.map((r) => (
                <div key={r.name} className="flex items-center gap-2.5 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
                  <span className="relative flex w-2.5 h-2.5"><span className="w-2.5 h-2.5 rounded-full bg-[#2563eb] ping-slow" /></span>
                  <span className="text-sm text-slate-700">{r.name}</span>
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs text-slate-600">Drag to rotate the globe · animated lines show active campaign routes.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
